export default __webpack_public_path__ + "static/media/archive.c088cdfc.svg";